'use client';
import Link from 'next/link';
import { twMerge } from 'tailwind-merge';
import { ILocalizedParams } from '../../models/ICommon';
import Image from 'next/image';
import { IGeneralSettings } from '../../models/IGeneralSettings';
import { IMenuItem } from '../../models/IMenuItem';
import { EremSocials } from './EremSocials';
import { IPlatformLinks } from '../../models/IPlatformLinks';
import { socialIcons } from '../../utils/socials';
import { IPlatformSocials } from '../../models/IPlatformSocials';
import { useState } from 'react';
import Arrow from './svg/Arrow';
import { appConfig } from '../../config';
import { IStaticPage } from '../../models/IStaticPage';
import { platformWebsites } from '../../utils/platformsMeta';
import FooterClose from './svg/FooterClose';
import FooterOpen from './svg/FooterOpen';


type Props = ILocalizedParams<{
  settings: IGeneralSettings; 
  platformsLinks: IPlatformLinks[]; 
  platformsSocials: IPlatformSocials[];
  staticPages: IStaticPage[];
}>;



export default function Footer(props: Props) {
  return (
    <>
    <DesktopFooter {...props}/>
    <MobileFooter {...props}/>
    </>
  )
}

function DesktopFooter({platformsLinks,platformsSocials,settings, staticPages}:Props) {

const socials = socialIcons.filter(s => settings.socials.find(ss => ss.type === s.type)).map(s => ({...s, url: settings.socials.find(ss => ss.type === s.type)?.url || ''}));

const [expanded, setExpanded] = useState<number | null>(null);
const toggleExpansion = (index: number) => {
  if (index === expanded) setExpanded(null);
  else setExpanded(index);
}
  return (
    
    <div className='hidden desktop:flex flex-col w-full'>
      <div className='bg-primaryReal-600 w-full'>

    <div className='grid grid-cols-1 desktop:grid-cols-3 justify-between gap-[120px]  py-[50px] px-[24px] desktop:px-0 max-w-[1296px] w-full mx-auto'>
      {platformsLinks.map((p,i) => {
        const platformSocials = platformsSocials.find(platform => platform.platform === p.platform)?.socials || [];
        const displayedSocials = socialIcons.filter(i => platformSocials.find(ps => ps.type === i.type)).map(i => ({...i, url: platformSocials.find(ps => ps.type === i.type)?.url || ''}));
        const isExpanded = expanded === i;
        return (
          <div key={`desktop-footer-platform-${i}`} className='flex flex-col'>
          <div className='flex items-center justify-between gap-[16px]'>
            <Link href={platformWebsites[p.platform]} target='_blank' className='w-fit h-fit grid place-items-center flex-shrink-0'>
            <Image src={p.logo} alt={`platform-${p.platform}`} height={90} width={90} className='h-[90px] w-[90px]' loading='lazy'/>
            </Link>
            <div className={twMerge('flex items-center rounded-[20px] w-fit gap-[16px]', isExpanded && '')}>
            {isExpanded ? (
                <>
            <div className='grid grid-cols-4 gap-[10px] py-[5px]' dir='ltr'>
              {displayedSocials.map(s => (
                <Link target='_blank' href={s.url} className='h-fit w-fit grid place-items-center [&>*]:h-[31px] [&>*]:w-[31px]'>
                  <s.Component/>
                </Link>
              ))}
            </div>
              <FooterClose className='cursor-pointer flex-shrink-0' onClick={() => toggleExpansion(i)}/>
                </>
            ): (
              <>
              <span className='text-white'>وسائل التواصل الاجتماعي</span>
              <FooterOpen className='cursor-pointer flex-shrink-0' onClick={() => toggleExpansion(i)}/>
                </>
            )}
            </div>
          </div>
          <div className='h-[1px] w-full bg-primaryReal-300 my-[20px]'/>

          <ul className='grid grid-cols-3 gap-x-[40px] gap-y-[20px]'>
            {p.menus.slice(0,6).map(m => (
              <li>

              <Link target='_blank' href={`${platformWebsites[p.platform]}${Number(m.targetType) === 3 ? '' : '/'}${m.destination}`} key={`platform-${p.platform}-${m.id}`} className='p text-white leading-[unset] flex items-center h-full'>
                  {m.title}
                </Link>
              </li>
            ))}
          </ul>
            <Link target='_blank' href={platformWebsites[p.platform]} className='mt-[20px] w-fit flex items-center'><p className='text-primaryReal-300 leading-[unset]'>زيارة الموقع</p></Link>
        </div>
    )})}


    </div>
    </div>
    <div className='h-fit bg-black dark:bg-transparent'>
      <div className='grid grid-cols-3 justify-between w-full max-w-[1296px] mx-auto h-full [&>*]:h-full min-h-[72px] gap-[24px] py-[16px]'>

      <p className='text-white'>{settings.publisherSettings.copyright}</p>
      <div className='flex items-center justify-center flex-wrap gap-[16px]'>
        {staticPages?.map(p => <Link className='text-white grid place-items-center cursor-pointer' href={`${appConfig.appBaseUrl}/${p.slug}`}>{p.title}</Link>)}
      </div>
      <div className='flex items-center justify-end gap-[16px]'>
        {/* @ts-ignore */}
        {socials.map(s => <Link href={s.url} target='_blank'><s.Component/></Link>)}
      </div>
      </div>
    </div>
    </div>
  )
}


function MobileFooter({platformsLinks,platformsSocials,settings, staticPages}: Props) {
  const [expanded, setExpanded] = useState<number | null>(0);
  const toggleExpansion = (index: number) => {
    if (index === expanded) setExpanded(null);
    else setExpanded(index);
  }

  const socials = socialIcons.filter(s => settings.socials.find(ss => ss.type === s.type)).map(s => ({...s, url: settings.socials.find(ss => ss.type === s.type)?.url || ''}));

  return (
<div className='flex desktop:hidden flex-col w-full'>
      <div className='bg-primaryReal-600 w-full'>

    <div className='grid grid-cols-1 desktop:grid-cols-3 justify-between gap-[80px]  py-[50px] px-[24px] desktop:px-0 max-w-[1296px] w-full mx-auto'>
      {platformsLinks.map((p,i) => {
        const platformSocials = platformsSocials.find(platform => platform.platform === p.platform)?.socials || [];
        const displayedSocials = socialIcons.filter(i => platformSocials.find(ps => ps.type === i.type)).map(i => ({...i, url: platformSocials.find(ps => ps.type === i.type)?.url || ''}));
        return (
          <div key={`mobile-footer-platform-${i}`} className='flex flex-col'>
          <div className='flex items-center justify-between'>
            <Link href={platformWebsites[p.platform]} target='_blank' className='w-fit h-fit grid place-items-center'>
            <Image src={p.logo} alt={`platform-${p.platform}`} height={90} width={90} className='h-[90px] w-[90px]' loading='lazy'/>
            </Link>
            <div className='flex gap-[24px]'>
            <div className='grid grid-cols-4 gap-[15px]'>
              {displayedSocials.map((s,j) => (
                <Link target='_blank' href={s.url} className='h-fit w-fit grid place-items-center [&>*]:h-[31px] [&>*]:w-[31px]' key={`mobile-static-pages-${j}`}>
                  <s.Component/>
                </Link>
              ))}
            </div>
              <div onClick={() => toggleExpansion(i)} className={twMerge('rounded-full aspect-square h-[31px] w-[31px] grid place-items-center cursor-pointer bg-primaryReal-900', expanded === i && 'bg-primaryReal-300')}>
                <Arrow className={twMerge('[&>*]:stroke-white transition-all duration-200', expanded === i && 'rotate-180 [&>*]:stroke-primaryReal-600')}/>
                </div>
            </div>
          </div>
          <div className='h-[1px] w-full bg-primaryReal-300 my-[20px]'/>

          <ul className={twMerge('grid grid-cols-3 gap-x-[40px] gap-y-[20px]', i !== expanded && 'hidden')}>
            {p.menus.slice(0,6).map(m => (
              <li>

              <Link target='_blank' href={`${platformWebsites[p.platform]}${Number(m.targetType) === 3 ? '' : '/'}${m.destination}`} key={`platform-${p.platform}-${m.id}`} className='p text-white leading-[unset] flex items-center h-full'>
                  {m.title}
                </Link>
              </li>
            ))}
            <Link target='_blank' href={platformWebsites[p.platform]} className='mt-[20px] w-fit flex items-center col-span-full'><p className='text-primaryReal-300 leading-[unset]'>زيارة الموقع</p></Link>
          </ul>
        </div>
    )})}


    </div>
    </div>
    <div className='min-h-[72px] bg-black dark:bg-transparent flex flex-col justify-center items-center gap-[24px] p-[24px]'>


{/* <p className='text-white'>{settings.publisherSettings.copyright}</p> */}
  <div className='flex items-center flex-wrap gap-x-[24px] gap-y-[16px] w-[80%] mx-auto justify-center'>
    {staticPages?.map(p => <Link className='text-white grid place-items-center cursor-pointer' href={`${appConfig.appBaseUrl}/${p.slug}`}>{p.title}</Link>)}
  </div>
<div className='flex items-center justify-end gap-[16px]'>
  {/* @ts-ignore */}
  {socials.map(s => <Link href={s.url} target='_blank'><s.Component/></Link>)}
</div>
      <p className='text-white'>{settings.publisherSettings.copyright}</p>
</div>
    </div>
    )

}